import { apiCall } from "api-calls/api-call"
import { CountryGroupDto, CreateCountryGroupDto, AddCountriesDto, RemoveCountriesDto } from "../store/types"

export const getAllCountryGroups = async(): Promise<CountryGroupDto[]> => {
  return apiCall({
    method: "GET",
    path: "games-v2/country-groups",
  })
}

export const getCountryGroupById = async(id: string): Promise<CountryGroupDto> => {
  return apiCall({
    method: "GET",
    path: `games-v2/country-groups/${id}`,
  })
}

export const createCountryGroup = async(data: CreateCountryGroupDto): Promise<CountryGroupDto> => {
  return apiCall({
    method: "POST",
    path: "games-v2/country-groups",
    body: data,
  })
}

export const updateCountryGroup = async(id: string, data: CreateCountryGroupDto): Promise<CountryGroupDto> => {
  return apiCall({
    method: "PUT",
    path: `games-v2/country-groups/${id}`,
    body: data,
  })
}

export const deleteCountryGroup = async(id: string): Promise<void> => {
  return apiCall({
    method: "DELETE",
    path: `games-v2/country-groups/${id}`,
  })
}

export const addCountriesToGroup = async(id: string, data: AddCountriesDto): Promise<CountryGroupDto> => {
  return apiCall({
    method: "POST",
    path: `games-v2/country-groups/${id}/add-countries`,
    body: data,
  })
}

export const removeCountriesFromGroup = async(id: string, data: RemoveCountriesDto): Promise<CountryGroupDto> => {
  return apiCall({
    method: "POST",
    path: `games-v2/country-groups/${id}/remove-countries`,
    body: data,
  })
}
